module.exports = __webpack_public_path__ + "static/img/联合医务背景@2x.fd71b47.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/联合医务背景@2x.png
// module id = +8jo
// module chunks = 0